export default class extends Controller {
  connect() {
    App.Helpers.xhrContentHandler(this.element, '[data-link=sort-column-remote]', this.element, true);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/involvement/involvement-projects-controller.js